// Client Info Card Component
// Displays client name, email, phone, language with quick contact actions

import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Mail, Phone, Globe } from 'lucide-react';
import StatusBadge from './StatusBadge';
import QuickActions from './QuickActions';
import RetainerActions from './RetainerActions';
import CMSExportDropdown from './CMSExportDropdown';

const ClientInfoCard = ({ 
  intake, 
  formatDate,
  generatingRetainer,
  onGenerateRetainer,
  onExportIntake
}) => {
  return (
    <Card className="border-slate-200" data-testid="client-info-card">
      <CardHeader>
        <div className="flex items-start justify-between">
          <div>
            <CardTitle 
              className="text-2xl font-bold text-slate-900"
              style={{ fontFamily: 'Manrope, sans-serif' }}
            >
              {intake.client_name}
            </CardTitle>
            <p className="text-slate-500 mt-1">
              Submitted on {formatDate(intake.submitted_at)}
            </p>
          </div>
          <StatusBadge status={intake.status} />
        </div>
      </CardHeader>
      <CardContent>
        <div className="grid sm:grid-cols-2 gap-4">
          {intake.client_email && (
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 bg-slate-100 rounded-lg flex items-center justify-center">
                <Mail className="w-5 h-5 text-slate-600" />
              </div>
              <div>
                <p className="text-xs text-slate-500 uppercase tracking-wide">Email</p>
                <p className="text-slate-900 font-medium">{intake.client_email}</p>
              </div>
            </div>
          )}
          {intake.client_phone && (
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 bg-slate-100 rounded-lg flex items-center justify-center">
                <Phone className="w-5 h-5 text-slate-600" />
              </div>
              <div>
                <p className="text-xs text-slate-500 uppercase tracking-wide">Phone</p>
                <p className="text-slate-900 font-medium">{intake.client_phone}</p>
              </div>
            </div>
          )}
          {/* Client Language Indicator */}
          {intake.detected_language && intake.detected_language !== 'en' && (
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 bg-purple-100 rounded-lg flex items-center justify-center">
                <Globe className="w-5 h-5 text-purple-600" />
              </div>
              <div>
                <p className="text-xs text-slate-500 uppercase tracking-wide">Primary Language</p>
                <p className="text-purple-700 font-medium">{intake.detected_language_name || intake.detected_language}</p>
              </div>
            </div>
          )}
        </div>

        {/* Quick Contact Buttons - only show if contact info exists */}
        <QuickActions 
          clientPhone={intake.client_phone} 
          clientEmail={intake.client_email} 
        />
        
        {/* Generate Retainer Agreement - always show */}
        <RetainerActions 
          intake={intake}
          generating={generatingRetainer}
          onGenerate={onGenerateRetainer}
        />
        
        {/* Export to CMS - always show */}
        <div className="mt-3">
          <CMSExportDropdown onExport={onExportIntake} />
          <p className="text-[10px] text-slate-400 mt-1 text-center">
            Import directly into your case management system
          </p>
        </div>
      </CardContent>
    </Card>
  );
};

export default ClientInfoCard;
